export default Object.freeze({
    Alert: 'Alert',
    Avatar: 'Avatar',
    BiometricToggle: 'BiometricToggle',
    Buttons: 'Buttons',
    Calendar: 'Calendar',
    Card: 'Card',
    CenterLayout: 'CenterLayout',
    Comments: 'Comments',
    ContentMeta: 'ContentMeta',
    CustomMap: 'CustomMap',
    Detail: 'Detail',
    Events: 'Events',
    Form: 'Form',
    FunnelForm: 'FunnelForm',
    FunnelFormStudentSelector: 'FunnelFormStudentSelector',
    Gallery: 'Gallery',
    GalleryListItem: 'GalleryListItem',
    GroupListItem: 'GroupListItem',
    Heading: 'Heading',
    Html: 'Html',
    IconText: 'IconText',
    Identification: 'Identification',
    ImpersonationSelector: 'ImpersonationSelector',
    LearningMoment: 'LearningMoment',
    List: 'List',
    ListItem: 'ListItem',
    MockDataToggle: 'MockDataToggle',
    NotificationHistory: 'NotificationHistory',
    NotificationList: 'NotificationList',
    NotificationSettings: 'NotificationSettings',
    NotificationToggle: 'NotificationToggle',
    NotificationsListItem: 'NotificationsListItem',
    Pagination: 'Pagination',
    Radio: 'Radio',
    ScoreCard: 'ScoreCard',
    SelectionList: 'SelectionList',
    SelectionSearch: 'SelectionSearch',
    SimpleListItem: 'SimpleListItem',
    SocialLinks: 'SocialLinks',
    SpaceListItem: 'SpaceListItem',
    SparkListItem: 'SparkListItem',
    Subscriptions: 'Subscriptions',
    Switch: 'Switch',
    Tabs: 'Tabs',
    TourStep: 'TourStep',
})
